import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';

const About = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "-100px" });

  return (
    <section id="about" ref={ref} className="container" style={{ position: 'relative' }}>
      <motion.div
        initial={{ opacity: 0, y: 50 }}
        animate={isInView ? { opacity: 1, y: 0 } : { opacity: 0, y: 50 }}
        transition={{ duration: 0.8 }}
      >
        <h2 className="section-title">
          About <span className="text-gradient">Me</span>
        </h2>
        
        <div className="glass-panel" style={{ padding: '3rem', position: 'relative', overflow: 'hidden' }}>
          <div style={{
            position: 'absolute', top: '-50%', left: '-50%', width: '200%', height: '200%',
            background: 'radial-gradient(circle, rgba(138,43,226,0.05) 0%, transparent 50%)',
            pointerEvents: 'none'
          }}></div>
          
          <p style={{ fontSize: '1.2rem', lineHeight: 1.8, color: 'var(--text-secondary)', marginBottom: '1.5rem' }}>
            An execution-driven leader architecting and scaling world-class <strong>AI Factories</strong>. With over 12-15+ years in high-level IT services and 5+ years spearheading applied <strong>Generative AI and Machine Learning</strong>, I design cutting-edge solutions for complex business challenges (LLM applications, conversational AI, computer vision).
          </p>
          <p style={{ fontSize: '1.2rem', lineHeight: 1.8, color: 'var(--text-secondary)', marginBottom: '1.5rem' }}>
            My core strength is acting as a <strong>trusted advisor to C-level clients</strong>, bridging AI strategy with practical execution. I specialize in <strong>Rapid Prototyping (POCs)</strong> to demonstrate immediate value through "vibe coding" methodologies, before orchestrating the end-to-end lifecycle for scalability, security, and SLA compliance. I actively own P&L for AI initiatives, ensuring delivery excellence while continuing to scale fullstack systems built across a 25-year comprehensive journey.
          </p>
          
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '2rem', marginTop: '3rem' }}>
            {[
              { label: 'Startups Built/Associated', value: '7' },
              { label: 'High-Value Products', value: '25+' },
              { label: 'Professionals Managed', value: '450+' },
              { label: 'Revenue Generation', value: '$10M+' }
            ].map((stat, i) => (
              <motion.div 
                key={i}
                initial={{ scale: 0.8, opacity: 0 }}
                animate={isInView ? { scale: 1, opacity: 1 } : { scale: 0.8, opacity: 0 }}
                transition={{ delay: 0.4 + (i * 0.1), duration: 0.5 }}
                style={{ textAlign: 'center', padding: '1.5rem', borderLeft: '2px solid var(--accent-cyan)', background: 'rgba(255,255,255,0.02)' }}
              >
                <h3 className="text-gradient" style={{ fontSize: '2rem', marginBottom: '0.5rem' }}>{stat.value}</h3>
                <p style={{ color: 'var(--text-secondary)' }}>{stat.label}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </motion.div>
    </section>
  );
};

export default About;
